<template>
  <div id="cont_main" style="position: absolute;left: 0; top: 0; background-color: #f3f3f3; z-index: 1500;">
    <div style="display: flex; align-items: center; width: 100vw; min-height: 100vh;">
          <div class="col-md-4 offset-md-4 col-xs-10 offset-xs-1 box-shadow-2 p-0">
              <div class="card border-grey border-lighten-3 m-0">
                  <div class="card-header no-border">
                      <div class="card-title text-xs-center">
                          <div class="p-1">
                            <img style="max-width: 70%; min-width: 50%;" src="../assets/pictures/me_logo.png" alt="branding logo">
                            <ul class="nav navbar-nav float-xs-right">  
                              <li class="dropdown dropdown-language nav-item">
                                <a id="dropdown-flag" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn dropdown-toggle nav-link">
                                
                                  <i ref="lang_btn" class="flag-icon" :class="$i18n.tc('lang.logo', $i18n.locale )"></i>
                                
                                </a>
                                
                                <div aria-labelledby="dropdown-flag" class="dropdown-menu">
                                  <a class="dropdown-item" :id="lang" v-for="(lang, index) in listLanguages" :key="index" @click="changeLanguage(lang)">
                                    <i class="flag-icon" :class="$i18n.getLocaleMessage(lang).lang.logo"></i> {{ $i18n.getLocaleMessage(lang).lang.title }}
                                  </a>
                                </div>
                              </li>
                            </ul>
                          </div>
                          
                      </div>

                  </div>
                  <div class="card-body collapse in">
                      <div class="card-block text-xs-center">
                          <div class="form-horizontal form-simple">
                          </div>

                          <h3>This page not found</h3>
                          <p>There is no page with this name.
                              <br> Check name of Page.</p>
                          <div class="mt-2">
                            <i class="icon-gear-a spinner font-large-2"></i>
                          </div>
                      </div>
                  </div>
                  <div class="card-footer">

                  </div>
              </div>
          </div>

      </div>

  </div>
</template>

<script>
    export default {
      name: "Maintenance",
      components: {},
      data() {
          return {
            image: {name: null, data: null},
            errors: [],            
          };
        },
        methods: {
          
          
         
        },
        computed:{
          listLanguages(){
            let arrLang = [];
            for (let i = 0; i < this.$i18n.availableLocales.length; i++) {
              arrLang[this.$i18n.getLocaleMessage(this.$i18n.availableLocales[i]).lang.id] = this.$i18n.availableLocales[i];
            }
            return arrLang;
          },
        },
        watch:{},
        mounted () {}
    }
</script>

<style scoped>
#cont_main{
  background-image: url('../assets/pictures/1.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
}
.img_cont{
  max-width: 60%;
}
.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
#file_loader {
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
	cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/pages/Maintenance.vue